import nextI18nextConfig from '@pylot/next-i18next.config'

let defaultLocale: string | undefined
export const getDefaultLocale = (): string => {
    if (typeof defaultLocale !== 'undefined') {
        return defaultLocale
    }

    defaultLocale = nextI18nextConfig?.i18n?.defaultLocale

    if (!defaultLocale) {
        defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE ?? 'en'
    }
    return defaultLocale
}
